<div class="content">
    <div class="message md-padding" fxLayout="row" fxLayout.xs="column" fxLayoutWrap>
      <h3>Product does not exist / Product number incorrect</h3>
    </div>
  </div>
  